import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import ExtendedSelect from 'components/extendedSelect';
import {
  Button, message, Modal, Tooltip
} from 'antd';
import { getKey, getLabel } from 'library/helpers';
import { Table } from 'components/Page';
import { list, load, update } from 'actions';
import _ from 'lodash';
import settings from 'settings';
import config from './config';

const mapDispatchToProps = dispatch => ({
  loadRoutes(searchText = '') {
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [{
      id: 'active',
      value: true
    }];

    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'name__icontains',
        value: searchText
      });
    }

    dispatch(list(
      REDUCER_KEY.travelRoutes.key, {
        page: 0,
        pageSize: settings.APP_CONFIG.dropListSize,
        filters,
        sorted
      }
    ));
  },
  loadUserRoutes(id) {
    return dispatch(load(REDUCER_KEY.userTravelRoutes.key, { id }));
  },
  saveRoutes(id, approved_route_ids) {
    const params = {
      id,
      approved_route_ids
    };
    return dispatch(update(REDUCER_KEY.userTravelRoutes.key, params))
      .catch((e) => {
        message.error(e.allErrors);
      });
  }
});

const mapStateToProps = state => ({
  userRoutes: {
    approved_routes: [],
    ...state.api.userTravelRoutes.data
  },
  routes: state.api.travelRoutes.data.results,
  inFlight: state.api.travelRoutes.data.inFlight
});

const UserTravelRoutes = ({
  objectId, routes, loadRoutes, loadUserRoutes, saveRoutes, userRoutes, readonly
}) => {
  const [selectedRoute, setSelectedRoute] = useState(undefined); // initialise selected Route
  const [enableAdd, setEnableAdd] = useState(false); // initialise selected Route
  const [selectedRoutes, setSelectedRoutes] = useState([]); // initialise selected Route
  /*
   ** @description Update state with new route and check warn users if exists
   ** @param route Object
   */
  useEffect(() => {
    // check to see if selected routes
    // contain the current selected router
    if (selectedRoute) {
      if (selectedRoutes.find(item => item.id === selectedRoute.key)) {
        Modal.error({
          title: 'Route Exists',
          content: `The route "${selectedRoute.label}" already exists in the list of approved routes`
        });
      }
      else {
        setEnableAdd(true);
      }
    }
    else {
      setEnableAdd(false);
    }
  }, [selectedRoute]);
  useEffect(() => {
    if (objectId) {
      loadUserRoutes(objectId)
        .then((response) => {
          setSelectedRoutes(response.approved_routes);
        });
    }
  }, [objectId]);
  /*
   ** @description Update the routes for the travel record
   ** @param route Object
   ** @triggers saveRoutes dispatch
   */
  const handleAddRoute = () => {
    setSelectedRoutes([...selectedRoutes.map(item => item), ...routes.filter(route => route.id === selectedRoute.key)
      .map(item => item)]);
    saveRoutes(objectId, [...selectedRoutes.map(item => item.id), selectedRoute.key])
      .then(() => {
        setSelectedRoute(undefined);
        loadUserRoutes(objectId);
      });
  };
  /*
   ** @description Update the routes for the travel record
   ** @param id Number
   ** @triggers saveRoutes dispatch
   */
  const handleDeleteRoute = (id) => {
    const newSelectedRoutes = [...selectedRoutes.filter(item => item.id !== id)];
    saveRoutes(objectId, newSelectedRoutes.map(item => item.id))
      .then(() => {
        setSelectedRoutes(newSelectedRoutes);
        setSelectedRoute(undefined);
        loadUserRoutes(objectId);
      });
  };

  return (
    <div className="bhp-user-travel-form-approved-routes bhp-container">
      <div className="bhp-route-picker-container">
        <div className="bhp-route-picker">
          <ExtendedSelect
            placeholder="Select Route"
            dataSource={routes}
            value={selectedRoute}
            optionKey={getKey}
            optionLabel={getLabel}
            onChange={setSelectedRoute}
            onSearch={loadRoutes}
            onFocus={loadRoutes}
            disabled={readonly}
          />
        </div>
        <Tooltip title="Add Item" placement="bottom">
          <Button icon="plus-circle-o" disabled={!enableAdd || readonly} onClick={() => handleAddRoute(selectedRoute)}>
            Add
          </Button>
        </Tooltip>
      </div>
      <Table
        reducer={{
          item: REDUCER_KEY.travelRoute,
          list: REDUCER_KEY.travelRoutes
        }}
        config={config}
        showInlineDelete={!readonly}
        dataSource={userRoutes && userRoutes.approved_routes}
        totalRecords={userRoutes && userRoutes.approved_routes.length}
        checkDelete={false}
        onDeleteItem={handleDeleteRoute}
      />
    </div>
  );
};

UserTravelRoutes.propTypes = {
  objectId: PropTypes.number,
  routes: PropTypes.array,
  loadRoutes: PropTypes.func,
  loadUserRoutes: PropTypes.func,
  saveRoutes: PropTypes.func,
  userRoutes: PropTypes.object,
  readonly: PropTypes.bool
};

UserTravelRoutes.defaultProps = {
  objectId: null,
  routes: [],
  loadRoutes() {
  },
  loadUserRoutes() {
  },
  saveRoutes() {
  },
  userRoutes: {},
  readonly: false
};

export default connect(mapStateToProps, mapDispatchToProps)(UserTravelRoutes);
